import * as React from "react"

const SvgMoneyFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M4 19C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V7C2 6.45 2.19583 5.97917 2.5875 5.5875C2.97917 5.19583 3.45 5 4 5H20C20.55 5 21.0208 5.19583 21.4125 5.5875C21.8042 5.97917 22 6.45 22 7V17C22 17.55 21.8042 18.0208 21.4125 18.4125C21.0208 18.8042 20.55 19 20 19H4ZM17 17H20V14C19.175 14 18.4688 14.2937 17.8812 14.8812C17.2937 15.4688 17 16.175 17 17ZM14.125 14.125C13.5417 14.7083 12.8333 15 12 15C11.1667 15 10.4583 14.7083 9.875 14.125C9.29167 13.5417 9 12.8333 9 12C9 11.1667 9.29167 10.4583 9.875 9.875C10.4583 9.29167 11.1667 9 12 9C12.8333 9 13.5417 9.29167 14.125 9.875C14.7083 10.4583 15 11.1667 15 12C15 12.8333 14.7083 13.5417 14.125 14.125ZM20 7V10C19.175 10 18.4688 9.70625 17.8812 9.11875C17.2937 8.53125 17 7.825 17 7H20ZM4 10C4.825 10 5.53125 9.70625 6.11875 9.11875C6.70625 8.53125 7 7.825 7 7H4V10ZM4 14C4.825 14 5.53125 14.2937 6.11875 14.8812C6.70625 15.4688 7 16.175 7 17H4V14Z" />
  </svg>
)
export default SvgMoneyFilled
